import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import { Texture } from './Texture.js';

var CanvasTexture = /*#__PURE__*/function (_Texture) {
  _inheritsLoose(CanvasTexture, _Texture);

  function CanvasTexture(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy) {
    var _this;

    _this = _Texture.call(this, canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy) || this;
    _this.needsUpdate = true;
    return _this;
  }

  return CanvasTexture;
}(Texture);

CanvasTexture.prototype.isCanvasTexture = true;
export { CanvasTexture };